/*MATERIAL UI*/
import { IconButton, Modal, Tooltip } from "@mui/material";
import { DataGrid, GridColumns } from "@mui/x-data-grid";

/*ICONS*/
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';

/*OTHERS*/
import React, { useEffect, useState } from "react";
import AcompanhamentoEntregaCIF from "../../components/classes/AcompanhamentoEntregaCIF";
import AcompanhamentoEntregaCIFDataset from "../../components/data/AcompanhamentoEntregaCIFDataset";
import AcompanhamentoCargaGridCarregamentosCIFModal from "./modaCarregamentosCIF/acompanhamentoCargaGridCarregamentosCIFModal";
import Parceiro from "../../components/classes/Parceiro";
// import { Data } from "react-csv/components/CommonPropTypes";
import { confirmAlert } from "react-confirm-alert";
import SkuHelper from "../../helper/skuHelper";
import Utils from "../../helper/utils";
import Filter from "./filter";
import PedidoPrevisaoEntrega from "../../components/classes/PedidoPrevisaoEntrega";
import PedidoPrevisaoEntregaDataset from "../../components/data/PedidoPrevisaoEntregaDataset";
import AcompanhamentoCargaCIFCompleteParameters from "../../components/classes/AcompanhamentoCargaCIFCompleteParameters";

import styles from './detail.module.css';

import { useTranslation } from "react-i18next";

type Data = Array<Record<string, any>>;

interface AcompanhamentoCargaGridCIFPropsTypes {
  parceiro: Parceiro;
}

export default function AcompanhamentoCargaGridCIF(props: AcompanhamentoCargaGridCIFPropsTypes) {
  const { t } = useTranslation();

  /*STATES*/
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState<Data>([]);
  const [acompanhamentosEntregaCif, setAcompanhamentosEntregaCif] = useState<AcompanhamentoEntregaCIF[]>([]);
  const [subTableRows, setSubTableRows] = useState<Data>([]);
  const [openSubTableModal, setOpenSubTableModal] = useState<boolean>(false);
  const [openFilter, setOpenFilter] = useState<boolean>(false);
  const [filterPedido, setFilterPedido] = useState<string>('');
  const [filterItem, setFilterItem] = useState<string>('');
  const [selectedPedido, setSelectedPedido] = useState<number>();
  const [selectedItem, setSelectedItem] = useState<string>('');
  const [newItemCount, setNewItemCount] = useState<number>(-1);
  const [acompanhamentoCargaCIFCompleteParameters, SetAcompanhamentoCargaCIFCompleteParameters] = useState<AcompanhamentoCargaCIFCompleteParameters>(new AcompanhamentoCargaCIFCompleteParameters());

  const acompanhamentoEntregaCIFDataset: AcompanhamentoEntregaCIFDataset = new AcompanhamentoEntregaCIFDataset();
  const pedidoPrevisaoEntregaDataset: PedidoPrevisaoEntregaDataset = new PedidoPrevisaoEntregaDataset();
  const columns: GridColumns = [
    {
      field: "id",
      headerName: t("common.id"),
      width: 80,
      align: "center",
      headerAlign: "center",
      renderHeader: (item) => {
        return <div>#</div>;
      },
    },
    {
      field: "pedido",
      headerName: t("common.order"),
      type: "string",
      width: 110,
      editable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "item",
      headerName: t("common.item"),
      type: "string",
      width: 110,
      editable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "sku",
      headerName: t("common.sku"),
      type: "string",
      width: 110,
      editable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "descricao",
      headerName: t("common.skuDescription.label"),
      type: "string",
      width: 240,
      editable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (item) => {
        return <div>{SkuHelper.getSKUName(item.row.sku)}</div>;
      },
    },
    {
      field: "quantidade",
      headerName: t("common.orderQuantity"),
      type: "string",
      width: 180,
      editable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (item) => {
        return (
          <p>
            {item.value ? item.value?.toString()?.replace('.', ',') : ""}
          </p>
        );
      },
    },
    {
      field: "quantidadeRecebidaSAP",
      headerName: t("common.amountReceived"),
      type: "string",
      width: 220,
      editable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (item) => {
        return (
          <p>
            {item.value ? item.value?.toString()?.replace('.', ',') : ""}
          </p>
        );
      },
    },
    {
      field: "quantidadeCarregada",
      headerName: t("common.quantityLoaded"),
      type: "string",
      width: 180,
      editable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (item) => {
        return (
          <p>
            {item.value ? item.value?.toString()?.replace('.', ',') : ""}
          </p>
        );
      },
    },
    {
      field: "saldo",
      headerName: t("common.balance"),
      type: "string",
      width: 180,
      editable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (item) => {
        return (
          <p>
            {item.value ? item.value?.toString()?.replace('.', ',') : ""}
          </p>
        );
      },
    },
    {
      field: "dataPrevistaChegada",
      headerName: t("common.expectedDeliveryDate"),
      type: "date",
      width: 180,
      editable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (item) => {
        return (
          <p>{item.row.dataEntrega ? new Date(item.row.dataEntrega).toLocaleDateString("pt-BR") : ''}</p>
        );
      },
    },
    {
      field: "dataEntregaReal",
      headerName: t("common.sapDeliveryDate"),
      type: "date",
      width: 180,
      editable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (item) => {
        return (
          <p>{item.row.dataEntregaReal ? new Date(item.row.dataEntregaReal).toLocaleDateString("pt-BR") : ''}</p>
        );
      },
    },
    {
      field: "dataCarregamento",
      headerName: t("common.lastLoadDate"),
      type: "date",
      width: 180,
      editable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (item) => {
        return (
          <p>
            {item.row.dataCarregamento ? new Date(item.row.dataCarregamento).toLocaleDateString("pt-BR") : ''}
          </p>
        );
      },
    },
    {
      field: "destino",
      headerName: t("common.destination"),
      type: "string",
      width: 180,
      editable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "carregamento",
      headerName: t("common.loadHistory"),
      type: "string",
      width: 180,
      editable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (item) => {
        return (
          <div>
            <Tooltip title={t("common.showLoadHistory")}>
              <span>
                <IconButton
                  onClick={() => handleClickShowSubTable(item)}
                  disabled={loading}
                >
                  <LocalShippingIcon />
                </IconButton>
              </span>
            </Tooltip>
          </div>
        );
      },
    }
  ];

  useEffect(() => {
    Utils.setDocumentTitle(t("pages.deliveriesCif.pageTitle"));
    fetchData();
  }, []);

  const fetchData = () => {
    getApiResult(filterPedido, filterItem);
  }

  const getApiResult = (filterPedido: string, filterItem: string) => {
    setLoading(true);
    var filtro = new AcompanhamentoCargaCIFCompleteParameters();
    filtro.Pedido = Number(filterPedido);
    filtro.Item = Number(filterItem);
    filtro.Clifor = props.parceiro.codigoFornecedorSAP.valueOf(),
      acompanhamentoEntregaCIFDataset
        .getAll(filtro)
        .then((result) => {
          setAcompanhamentosEntregaCif(result);
          fillTable(result);
          setLoading(false);
        });
  }

  const fillTable = (acompanhamentoEntregaCIFArr: AcompanhamentoEntregaCIF[]) => {
    let gridData: Data = [];
    if (acompanhamentoEntregaCIFArr !== undefined && acompanhamentoEntregaCIFArr.length > 0) {
      acompanhamentoEntregaCIFArr.forEach(
        (item: AcompanhamentoEntregaCIF, index: number) => {
          let json = {
            id: index,
            pedido: item.pedido,
            item: item.item,
            quantidade: item.quantidadePedido,
            quantidadeRecebidaSAP: item.quantidadeRecebida,
            quantidadeCarregada: item.quantidadeCarregada,
            saldo: item.saldo,
            dataEntrega: item.dataEntrega,
            dataEntregaReal: item.dataEntrega,
            dataCarregamento: item.dataUltimoCarregamento,
            destino: item.destino,
            sku: item.sku
          };

          gridData.push(json);
        }
      );
    }
    setRows(gridData);
  }

  const fillSubTable = (previsaoEntregaArr: PedidoPrevisaoEntrega[]) => {
    let gridData: Data = [];
    previsaoEntregaArr.forEach(
      (item: PedidoPrevisaoEntrega) => {
        let json = JSON.parse(PedidoPrevisaoEntrega.toJson(item));
        gridData.push(json);
      }
    );
    setSubTableRows(gridData);
  }

  const handleClickShowSubTable = (gridItem: any) => {

    setLoading(true);
    setSelectedPedido(gridItem.row.pedido);
    setSelectedItem(gridItem.row.item);

    pedidoPrevisaoEntregaDataset
      .get(props.parceiro.codigoFornecedorSAP.valueOf(), +gridItem.row.pedido, +gridItem.row.item)
      .then((result) => {
        fillSubTable(result);
        setLoading(false);
        setOpenSubTableModal(true);
      });
  }

  const handleCloseSubTableModal = () => {
    setOpenSubTableModal(false);
  }

  const handleSalvarClick = async () => {
    setLoading(true);

    let adjustedRows = subTableRows.map((x: any) => {
      x.quantidadeCarregada = x.quantidadeCarregada ? x.quantidadeCarregada.toString().replace(',', '.') : 0;
      x.quantidadeQuebra = x.quantidadeQuebra ? x.quantidadeQuebra.toString().replace(',', '.') : 0;
      return x;
    })

    pedidoPrevisaoEntregaDataset.update(adjustedRows, props.parceiro.codigoFornecedorSAP.valueOf()).then((success) => {
      setLoading(false);
      if (success == true) {
        fetchData();
        confirmAlert({
          title: t("pages.deliveriesCif.text.loadingHistory"),
          message: t("pages.deliveriesCif.text.dataSaved"),
          buttons: [
            {
              label: t("common.ok"),
              onClick: () => { },
            },
          ],
        })
      }
    });
    setOpenSubTableModal(false);
  }

  const handleClickOpenFilter = () => {
    setOpenFilter(true);
  };

  const handleClickFilter = async () => {
    setOpenFilter(false);
    await fetchData();
  }

  const handleClickClearFilter = async () => {
    await setFilterItem("");
    await setFilterPedido("");
    getApiResult("", "");
  }

  const handleClickAddNewCarregamento = () => {
    setNewItemCount(newItemCount + -1);
    let itemBase = acompanhamentosEntregaCif.find(x => x.pedido == selectedPedido && x.item == selectedItem);

    if (!itemBase)
      throw t("pages.deliveriesCif.text.selectedOrderAndItemNotFound");

    let newCarregamento: PedidoPrevisaoEntrega = new PedidoPrevisaoEntrega(
      newItemCount,
      itemBase.pedido,
      +itemBase.item,
      0,
      new Date(),
      new Date(),
      "",
      "",
      itemBase.sku + '',
      SkuHelper.getSKUName(itemBase.sku),
      undefined,
      undefined,
      undefined,
      undefined,
      undefined
    );
    let subTableNewRow = JSON.parse(PedidoPrevisaoEntrega.toJson(newCarregamento));
    setSubTableRows([subTableNewRow, ...subTableRows]);
  }

  const handleClickRemoveCarregamento = (event: any) => {
    let subTableKeepRows = subTableRows.filter(x => JSON.parse(JSON.stringify(x)).id != event.row.id) ?? [];
    let subTableRemoveRow = subTableRows.find(x => JSON.parse(JSON.stringify(x)).id == event.row.id);
    let newRow = JSON.parse(JSON.stringify(subTableRemoveRow));
    newRow.deletar = true;

    setSubTableRows([newRow, ...subTableKeepRows]);
  }

  const handleClickRevertRemoveCarregamento = (event: any) => {
    let subTableKeepRows = subTableRows.filter(x => JSON.parse(JSON.stringify(x)).id != event.row.id) ?? [];
    let subTableRemoveRow = subTableRows.find(x => JSON.parse(JSON.stringify(x)).id == event.row.id);
    let newRow = JSON.parse(JSON.stringify(subTableRemoveRow));
    newRow.deletar = false;

    setSubTableRows([newRow, ...subTableKeepRows]);
  }

  return (
    <>
      {/* Ações no Cabeçalho */}
      <div className="containerToolbar">
        {filterItem == '' && filterPedido == '' ? (
          <Tooltip title={t("pages.deliveriesCif.text.enableFiltering")}>
            <span>
              <IconButton
                onClick={handleClickOpenFilter}
                disabled={!(rows.length >= 0) || loading}
              >
                <FilterAltIcon />
              </IconButton>
            </span>
          </Tooltip>
        ) : (
          <Tooltip title={t("pages.deliveriesCif.text.disableFiltering")}>
            <span>
              <IconButton
                onClick={handleClickClearFilter}
                disabled={loading}
              >
                <FilterAltOffIcon />
              </IconButton>
            </span>
          </Tooltip>
        )}
      </div>
      <div className={styles.table}>

        {/* Tabela de Carregamentos */}
        <DataGrid
          loading={loading}
          rows={rows}
          columns={columns}
          rowsPerPageOptions={[50, 100, 250, 500]}
          onRowClick={handleClickShowSubTable}
          style={{ cursor: 'pointer' }}
        />
      </div>

      {/* Modal Histórico de Carregamentos */}
      <Modal
        open={openSubTableModal}
        onClose={handleCloseSubTableModal}
        sx={{
          display: "flex",
          "justifyContent": "center",
          "alignItems": "center",
        }}
      >
        <>
          <AcompanhamentoCargaGridCarregamentosCIFModal
            handleClose={handleCloseSubTableModal}
            handleSalvarClick={handleSalvarClick}
            data={subTableRows}
            setRows={setSubTableRows}
            fileWasUploaded={fetchData}
            parceiro={props.parceiro}
            addNewCarregamento={handleClickAddNewCarregamento}
            removeCarregamento={handleClickRemoveCarregamento}
            revertRemoveCarregamento={handleClickRevertRemoveCarregamento}
          />
        </>
      </Modal>

      {/* Filtro de Carregamentos */}
      <Filter
        getApiResult={getApiResult}
        openFilter={openFilter}
        setOpenFilter={setOpenFilter}
        filterItem={filterItem}
        setFilterItem={setFilterItem}
        filterPedido={filterPedido}
        setFilterPedido={setFilterPedido}
        handleClickFilter={handleClickFilter}
      ></Filter>
    </>
  );
}
